import { Injectable } from '@angular/core';

@Injectable()
export class ModalSharedService {
  private modalInstance: any = {};

  generateUniqueKey() {
    const randomKey = new Date().valueOf() + Math.random() * 1000;
    if (this.getInstance(randomKey)) {
      this.generateUniqueKey();
    } else {
      return randomKey;
    }
  }
  setInstance(instance, key) {
    this.modalInstance[key] = instance;
  }
  getInstance(key) {
    return this.modalInstance[key];
  }
  destroyInstance(key) {
    delete this.modalInstance[key];
  }
}
